import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";

type FAQItem = {
  question: string;
  answer: string;
};

type FAQType = Record<string, Array<FAQItem>>;

const FAQS: FAQType = {
  AE: [
    {
      question: "مدت زمان صدور ویزای دبی چقدر است؟",
      answer:
        "فرایند صدور ویزای دبی به‌طور معمول 1 تا 3 روز کاری زمان می‌برد. درصورتی که نیاز به بررسی بیشتر باشد، این فرایند ممکن است 7 تا 10 روز کاری زمان ببرد."
    },
    {
      question: "اعتبار ویزای دبی چقدر است؟",
      answer:
        "ویزای توریستی دبی می‌تواند به مدت ۳۰ روز یا ۹۰ روز، یک بار ورود یا چند بار ورود صادر شود."
    },
    {
      question: "آیا ویزای دبی قابل تمدید است؟",
      answer: `بدون اینکه از کشور خارج شوید می‌توانید ویزای دبی را تمدید کنید. تمدید ویزای دبی ۳۰ روزه است و می‌توانید ویزای خود را از ${replaceSnappTripBasedOnChannel(
        "اسنپ تریپ"
      )} تمدید کنید.`
    },
    {
      question: "انواع ویزای دبی کدامند؟",
      answer:
        "برای اینکه بتوانید ویزای دبی را اخذ کنید، راه‌های مختلفی دارید چرا که انواع ویزای دبی عبارتند از: ویزای جستجوی کار، ویزای اسپانسری شرکت، ویزای تحصیلی، ویزای بازنشستگی و ویزای خانواده."
    },
    {
      question: "برای اخذ ویزای دبی چه مدارکی لازم است؟",
      answer: `برای گرفتن ویزای دبی به اسکن پاسپورت، شناسنامه، کارت ملی، عکس 4*3 نیاز داریم.
      ریجکت شدن ویزای دبی دلایل مختلفی می‌تواند داشته باشد. از مهم‌ترین دلایل ریجکتی می‌توان این موارد را نام برد: مسائل امنیتی موضوع سیاسی، داشتن ویزای فعال، عدم استفاده از ویزای قبلی، تخلف‌های مسافرتی و مهاجرتی مانند کار با ویزای توریستی، اقامت بیش از اعتبار ویزا، ارتکاب جرم (کلاهبرداری، سرقت و…)، ارائه مدارک جعلی.`
    },
    {
      question: "مهم‌ترین دلایل ریجکتی کدامند؟",
      answer:
        "ریجکت شدن ویزای دبی دلایل مختلفی می‌تواند داشته باشد. از مهم‌ترین دلایل ریجکتی می‌توان این موارد را نام برد: مسائل امنیتی موضوع سیاسی، داشتن ویزای فعال، عدم استفاده از ویزای قبلی، تخلف‌های مسافرتی و مهاجرتی مانند کار با ویزای توریستی، اقامت بیش از اعتبار ویزا، ارتکاب جرم (کلاهبرداری، سرقت و…)، ارائه مدارک جعلی."
    }
  ]
};

export { FAQS };
export type { FAQType };
